import React from 'react';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

interface UploadSummaryProps {
  rowsLength: number;
  rowErrors: any[];
  validRowsLength: number;
  isValidRows: boolean;
  onSave: () => void;
  onCancel: () => void;
}

const UploadSummary: React.FC<UploadSummaryProps> = ({
  rowsLength,
  rowErrors,
  validRowsLength,
  isValidRows,
  onSave,
  onCancel,
}) => {
  return (
    <>
        <div className="text-base font-semibold text-gray-700">📊 Upload Summary</div>
   

      {/* Hint under record summary */}
      <div className="bg-blue-50 border-l-8 border-blue-400 rounded-sm p-3 text-sm text-blue-800 flex items-start gap-2">
  <FontAwesomeIcon icon={faPencil} className="mt-1 text-blue-500" /> &nbsp;Double click on cell to edit value
      </div>

    <div className="flex flex-wrap gap-6 text-sm mb-1">
        <div className="text-gray-700">
          Total Records: <span className="font-semibold">{rowsLength}</span>
        </div>
        <div className="text-red-600">
          Total Errors: <span className="font-semibold">
            {rowErrors.filter(err => err && Object.keys(err).length > 0).length}
          </span>
        </div>
        <div className="text-green-600">
          Valid Records: <span className="font-semibold">{validRowsLength}</span>
        </div>
      </div>

        {/* Action buttons */}
        <div className="flex gap-2">
          <Button
            type="primary"
            onClick={onSave}
            disabled={!isValidRows}
          >
            Save
          </Button>
          <Button danger onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </>
  );
};

export default UploadSummary;